module.exports = __webpack_public_path__ + "fonts/Adelle_Italic.ce949a7e.woff";